<template>
  <div>
    <espondiloartrites-axial-summary v-if="predominantSymptom === 'AXIAL'" ref="summaryComponent" />
    <espondiloartrites-periferico-summary v-else-if="predominantSymptom === 'PERIFERICO'" ref="summaryComponent" />
    <div v-else>
      <p>Neste espaço serão exibidos os SCORES da Espondiloartrites para o paciente.</p>
      <p>Para iniciar os cálculos, primeiro é preciso definir o sintoma predominante no passo Anamnese &gt; Sintomas</p>
    </div>
  </div>
</template>

<script>
import EspondiloartritesAxialSummary from '../summary/EspondiloartritesAxialSummary.vue'
import EspondiloartritesPerifericoSummary from '../summary/EspondiloartritesPerifericoSummary.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap, mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')

export default {
  components: { EspondiloartritesAxialSummary, EspondiloartritesPerifericoSummary },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
    predominantSymptom() {
      const symptomsData = this.getPhaseDataByKey('sintomas')

      if (!symptomsData) {
        return null
      }

      return symptomsData.predominantSymptom
    },
  },
  watch: {
    predominantSymptom(newVal) {
      if (!newVal) {
        this.setAttendanceSummary(null)
      }
    },
  },
  methods: {
    ...attendanceActionsMap(['setAttendanceSummary']),
  },
}
</script>

<style scoped></style>
